import React from 'react';
import CrmAvatar from './CrmAvatar';

function CrmDetailHeader({
  avatarProps,
  title,
  subtitle,
  primaryButton,
  secondaryButton,
  onMoreClick,
  onAvatarFileSelect,
}) {
  return (
    <div className="mb-3" style={{ padding: '8px 0' }}>
      <div className="d-flex align-items-center justify-content-between">
        <div className="cdp-header-contact" style={{ minWidth: 0, flex: 1 }}>
          <CrmAvatar {...avatarProps} size={56} className="team-avatar-lg" editable={!!onAvatarFileSelect} onFileSelect={onAvatarFileSelect} />
          <div style={{ minWidth: 0, overflow: 'hidden' }}>
            <h1 className="mb-0" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: "'Open Sans', sans-serif", fontSize: 20, fontWeight: 600, lineHeight: '30px', color: 'var(--sl-text-primary)' }}>{title}</h1>
            {subtitle && <p className="mb-0" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: "'Open Sans', sans-serif", fontSize: 16, fontWeight: 400, lineHeight: '24px', color: 'var(--sl-text-tertiary)' }}>{subtitle}</p>}
          </div>
        </div>

        <div className="d-flex align-items-center" style={{ flexShrink: 0, marginLeft: 16, gap: 12 }}>
          {secondaryButton && (
            <button
              type="button"
              className="btn btn-setlist-secondary"
              onClick={secondaryButton.onClick}
              disabled={secondaryButton.disabled}
            >
              <span>{secondaryButton.label}</span>
            </button>
          )}
          {primaryButton && (
            <button
              type="button"
              className="btn btn-setlist-secondary-color"
              onClick={primaryButton.onClick}
            >
              <span>{primaryButton.label}</span>
            </button>
          )}
          {onMoreClick && (
            <button
              type="button"
              className="btn btn-setlist-secondary"
              style={{ width: 40, height: 40, padding: 10 }}
              onClick={onMoreClick}
              aria-label="More actions"
            >
              <i className="fal fa-ellipsis-v" aria-hidden="true" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default CrmDetailHeader;
